//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createContext } from 'react';

import PartialCuid from '@models/PartialCuid';

export interface IRangeSelectedItem {
  index: number;
  cuid: PartialCuid;
}

export interface IRangeSelectConfig {
  orderedPartialCuids: PartialCuid[];
  // Null allows for an initial undefined item and for resets of the range select flow
  lastSelectedItem: IRangeSelectedItem | null;
  setLastSelectedItem: (item: IRangeSelectedItem | null) => void;
}

// Initialize with some default values.
// These will be overriden with the Provider in our grid components.
export const ContentCardRangeSelectContext = createContext<IRangeSelectConfig>({
  orderedPartialCuids: [],
  lastSelectedItem: null,
  setLastSelectedItem: () => null,
});
